export default __webpack_public_path__ + "static/1382-6c9126103d3d55cad9a6d01395c79de8.gif";